import { Component, Prop, Vue } from 'vue-property-decorator';
import { buildPeerEvaluationAction } from '@/helpers/peer-evaluation';
import { MemberPeerEvaluationDTO, UserDTO } from '@/models';
import { updatePeerRatingPoint } from '@/services/project';
import EmojiRating from './emoji-rating/EmojiRating.vue';
import PopupMenu from '@/components/common/popup-menu/PopupMenu.vue';
import UserInformation from '@/components/common/user-information/UserInformation.vue';

@Component({
  components: {
    EmojiRating,
    PopupMenu,
    UserInformation
  }
})
export default class PopupPeerRating extends Vue {
  @Prop() updatePeerEvaluations: () => void;

  $refs!: {
    popupRef: HTMLFormElement;
  };

  private isEditing = false;
  private peerEvaluation = {
    recipient: { id: -1 } as UserDTO
  } as MemberPeerEvaluationDTO;

  setMemberPoint(memberRated: MemberPeerEvaluationDTO): void {
    this.peerEvaluation = { ...this.peerEvaluation, ...memberRated };
  }

  async onSave(): Promise<void> {
    const peerEvaluationResponse = await updatePeerRatingPoint(buildPeerEvaluationAction(this.peerEvaluation));
    this.$emit('updatePeerEvaluations', peerEvaluationResponse.data);
    this.onCancel();
  }

  onCancel(): void {
    this.$refs.popupRef.closeMenu();
  }

  openMenu(peerEvaluation: MemberPeerEvaluationDTO, isEditing: boolean): void {
    this.peerEvaluation = peerEvaluation;
    this.isEditing = !isEditing;
    this.$refs.popupRef.openMenu();
  }

  get isSaveButtonDisabled(): boolean {
    const {
      accountabilityPoint,
      communicationPoint,
      personalAttributesPoint,
      professionalConductPoint,
      supportivenessPoint
    } = this.peerEvaluation;
    return (
      accountabilityPoint === 0 ||
      communicationPoint === 0 ||
      personalAttributesPoint === 0 ||
      professionalConductPoint === 0 ||
      supportivenessPoint === 0
    );
  }
}
